module.exports = __webpack_public_path__ + "img/face-vomit.3b0a69e5.svg";